import CoverageDescription from './CoverageDescription';
import PassengersDetails from './PassengersDetails';
import { useEffect, useState } from 'react';
import { getAssistCountries } from '@shared/services/services';
import SuccessLayout from '@shared/components/SuccessLayout';

function encontrarPaises(paises, pasajeros = []) {
  return pasajeros.map(pasajero => {
    const paisEncontrado = paises.find(
      pais =>
        pais.code === (pasajero.country ? pasajero.country : pasajero.codigo)
    );
    return paisEncontrado ? { ...paisEncontrado } : null;
  });
}

const Contenido = ({ datos }) => {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    fetchCountries();
  }, []);

  const fetchCountries = async () => {
    let result = await getAssistCountries();
    result = encontrarPaises(result, datos?.state?.passengers);
    setCountries(result);
  };

  return (
    <SuccessLayout>
      {/* Izquierda */}
      <PassengersDetails
        storagePassengers={datos?.state?.storagePassengers}
        passengers={datos?.state?.passengers ?? []}
        countries={countries}
      />

      {/* Derecha */}
      <CoverageDescription
        storagePassengers={datos?.state?.storagePassengers}
        cardData={datos.cardData}
        subsidiary={datos.subsidiary}
        seller={datos.seller}
      />
    </SuccessLayout>
  );
};

export default Contenido;
